import React from 'react';
import {MESSAGE_ERROR} from "../constants";
import {sendMessage} from "../actions";
import {useDispatch} from "react-redux";

export default function useErrorMessage() {
    const dispatch = useDispatch();

    return message => dispatch(sendMessage(MESSAGE_ERROR, message));
}